<template>

<div class="order-query-box">
    <div class="query-1">
        <!-- <div class="query-row">
            <div class="query-item">
                <div class="query-item-title">平台类型：</div>
                <div class="query-item-content">
                    <label class="custom-radio" @click="onPlatformChange(0)">
                        <input type="radio" name="platform" value="0" v-model="query.platform">
                        <span class="custom-radio-btn">全部</span>
                    </label>
                    <label class="custom-radio" @click="onPlatformChange(1)">
                        <input type="radio" name="platform" value="1" v-model="query.platform">
                        <span class="custom-radio-btn"><i class="iconfont" style="color: #E9501E; font-size:18px; margin-right:5px;">&#xe636;</i>虾皮</span>
                    </label>
                    <label class="custom-radio" @click="onPlatformChange(2)">
                        <input type="radio" name="platform" value="2" v-model="query.platform">
                        <span class="custom-radio-btn"><i class="iconfont" style="color: #f200ca; margin-right:5px;">&#xe602;</i>MOMO</span>
                    </label>
                </div>
            </div>
        </div>  -->
        <div class="query-row" style="padding-top: 15px;">
            <div class="query-item">
                <div class="query-item-title">所属店铺：</div>
                <div class="query-item-content">
                    <el-input type="text" style="width: 150px;" @input="getShops"  name="shopName" size="small" placeholder="请输入关键词" v-model="query.shopName" />
                    <label class="custom-radio" @click.prevent="onShopSelect(0)">
                        <input type="radio" name="shopId" value="0" v-model="query.shopId">
                        <span class="custom-radio-btn">全部</span>
                    </label>
                    <label class="custom-radio"
                           v-for="shop in (showAllShops ? shops : shops.slice(0, 10))"
                           :key="shop.id"
                           @click.prevent="onShopSelect(shop.id)"
                           >
                        <input type="radio" name="shopId" :value="shop.id" v-model="query.shopId">
                        <span class="custom-radio-btn">{{shop.actualName?shop.actualName:shop.name}}</span>
                    </label>
                    <button
                      v-if="!showAllShops && shops.length > 10"
                      class="more-btn"
                      @click="showAllShops = true"
                    >
                      更多(+{{ shops.length - 10 }})
                    </button>
                    <button
                      v-if="showAllShops && shops.length > 10"
                      class="more-btn"
                      @click="showAllShops = false"
                    >
                      收起
                    </button>
                </div>
            </div>
        </div>
        <div style="width: 100%; height: 1px; margin: 15px 0px; background: #f2f3ff;"></div>
        <div class="query-grid">
            <div class="query-grid-cell1">
                <div class="query-grid-item">
                    <div class="query-item-title">订单编号：</div>
                    <xm-batch-input v-model="query.code" ></xm-batch-input>
                </div>
                <div class="query-grid-item">
                    <div class="query-item-title">单号模糊：</div>
                    <el-input clearable size="small" placeholder="请输入订单编号" v-model="query.codeLike" />
                </div>
                <div class="query-grid-item">
                    <div class="query-item-title">快递单号：</div>
                    <div class="input-checkbox-flex">
                        <el-input class="input-flex" name="innerExpCode" clearable size="small" placeholder="请输入快递单号" v-model="query.innerExpCode" />
                        <!-- <el-checkbox v-model="query.isLogistics" class="checkbox-flex">包含</el-checkbox> -->
                    </div>
                </div>
                <div class="query-grid-item">
                    <div class="query-item-title">采购时间：</div>
                    <el-date-picker size="small" style="width: 100%;"
                        v-model="query.PurchaseDate" clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </div>
                <div class="query-grid-item">
                    <div class="query-item-title">创建时间：</div>
                    <el-date-picker size="small" style="width: 100%;"
                        v-model="query.Date" clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </div>
                <div class="query-grid-item">
                    <div class="query-item-title">商品信息：</div>
                    <el-select
                      class="select-100"
                      v-model="currentSearchType"
                      size="small"
                      placeholder="请选择"
                      @change="onSearchTypeChange"
                    >
                      <el-option
                        v-for="item in searchTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      class="input-flex"
                      type="text"
                      :name="currentSearchType"
                      size="small"
                      clearable
                      :placeholder="currentPlaceholder"
                      v-model="query[currentSearchType]"
                    />
                </div>
            </div>
            <!-- <div class="query-grid-cell3" >
                <div style="width: 1px; height: 100%; background: #f2f3ff; margin-right: 20px; margin-left: 10px;"></div>
                <xm-primary-button icon="el-icon-search" @click="search" color="rgba(0, 82, 217)" radius="2px">
                    搜索
                </xm-primary-button>
            </div> -->
        </div>
        <div style="width: 100%; height: 1px; margin-bottom: 15px; margin-top: 5px; background: #f2f3ff;"></div>
        <div class="query-row" style="display: flex; gap: 15px; flex-wrap: wrap;">
            <xm-select style="width: 180px;" label="有无链接" :options="buyLinkOptions" v-model="query.isBuyLink" placeholder="请选择" clearable></xm-select>
            <xm-select style="width: 180px;" label="是否采购" :options="purchaseOptions" v-model="query.isPurchase" placeholder="请选择" clearable></xm-select>
            <xm-select style="width: 180px;" label="商家是否发货" :options="purchaseOptions" v-model="query.isSend" clearable></xm-select>
            <xm-select style="width: 180px;" label="剩余发货时间" :options="dateOptions" v-model="query.remainTime" clearable></xm-select>
            <xm-select style="width: 180px;" label="货到付款" :options="expCodTypes" v-model="query.expCod" clearable></xm-select>
        </div>
    </div>

    <el-dialog title="批量输入订单编号" :visible.sync="batchInputCodeVisible" width="500">
        <el-input type="textarea" :rows="15" v-model="batchInputCode" placeholder="多个用空格、换行、逗号分隔，支持复制粘贴Excel单元格">

        </el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleBatchInputCode">确定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import XmSelect from '@/components/XmSelect.vue';
// import XmPrimaryButton from '@/components/XmPrimaryButton.vue';
// import XmPlainButton from '@/components/XmPlainButton.vue';
import XmDropdown from '@/components/XmDropdown.vue';
// import XmPlainDropdown from '@/components/XmPlainDropdown.vue';
import XmBatchInput from '@/components/XmBatchInput.vue';

export default {
    components: {
        XmSelect,
        // XmPrimaryButton,
        // XmPlainButton,
        // XmDropdown,
        // XmPlainDropdown,
        XmBatchInput
    },
    data() {
        return {
            batchInputCodeVisible: false,
            isSyncExpressDisabled: false, // 新增按钮禁用状态
            batchInputCode: '',
            shops: [],
            query: {
                platform: '0',
                shopName: '',
                shopId: 0,
                code: '',
                codeLike: '',
                innerExpCode: '',
                // isLogistics: false,
                Date: [],
                expCode: '',
                productName: '',
                productSpec: '',
                sku: '',
                variationSku: '',
                id: '',
                stockId: '',
                isPurchase: null,//是否采购
                isBuyLink: null,//有无链接
                isSend: null,//上家是否发货
                isRemark: null,//是否备注
                remainTime: null,//剩余发货时间
                expCod:null,//付款方式 1 货到付款 3 纯配送
                isCancel: false,//取消单
                isPay: false,//货到付款
                sortType: null,//排序类型
                PurchaseDate: [],//采购时间
            },
            currentSearchType: 'productSpec',
            currentPlaceholder: '请输入查询码',
            showAllShops: false,
            searchTypes: [
                {
                    label: '商品规格',
                    value: 'productSpec',
                    placeholder: '请输入商品规格'
                },
                {
                    label: 'SKU',
                    value: 'sku',
                    placeholder: '请输入SKU'
                },
                {
                    label: '货号',
                    value: 'variationSku',
                    placeholder: '请输入货号'
                },
                // {
                //     label: '查询码',
                //     value: 'expCode',
                //     placeholder: '请输入查询码'
                // },
                // {
                //     label: '商品名称',
                //     value: 'productName',
                //     placeholder: '请输入商品名称'
                // },
                // {
                //     label: '订单编号',
                //     value: 'orderCode',
                //     placeholder: '请输入订单编号'
                // },
                // {
                //     label: '详情',
                //     value: 'id',
                //     placeholder: '请输入详情ID'
                // },
                // {
                //     label: '订单ID',
                //     value: 'stockId',
                //     placeholder: '请输入订单ID'
                // },
                    
            ],
            purchaseOptions: [
                // {
                //     label: '不限',
                //     value: '0'
                // },
                {
                    label: '是',
                    value: '1'
                },
                {
                    label: '否',
                    value: '2'
                }
            ],
            buyLinkOptions: [
                {
                    label: '有',
                    value: '1'
                },
                {
                    label: '无',
                    value: '2'
                }
            ],
            dateOptions: [
                {
                    label: '不足24小时',
                    value: '0'
                },
                {
                    label: '不足48小时',
                    value: '1'
                },
                {
                    label: '不足72小时',
                    value: '2'
                }
            ],
            expCodTypes: [
                {
                    label: '是',
                    value: 1
                },
                {
                    label: '否',
                    value: 3
                }
            ],
            printOptions: [
                {
                    label: '打印货单',
                    icon: 'el-icon-printer',
                    command: 'print'
                },
                {
                    label: '打印面单',
                    icon: 'el-icon-takeaway-box',
                    command: 'printPage'
                }
            ],
            caigouOptions: [
                {
                    label: '批量采购',
                    icon: 'el-icon-shopping-cart-full',
                    command: 'print'
                }
            ],
        }
    },
    mounted(){
        this.getShops();
        this.onSearchTypeChange(this.currentSearchType);
    },
    methods:{
        refreshSyncButton(){
            this.isSyncExpressDisabled = false;
        },
        getShops(queryString){

            let param = {
                start: 0,
                name:queryString,
            }
            
            this.$axios.post(
                this.$kit.api.shop.list, 
                param
            ).then((result) => {
                if(result.status){
                    this.shops = result.data.list.map(d => {
                        return {
                            id: d.shopId,
                            name: d.name,
                            actualName: d.actualName,
                        }
                    });
                }
            })
        },
        syncExpress() {
            this.isSyncExpressDisabled = true;
            this.$emit('syncExpress', '');
        },
        onSearchTypeChange(val) {
            const type = this.searchTypes.find(item => item.value === val);
            this.currentPlaceholder = type ? type.placeholder : '';
            //删除其他的值
            this.query.productSpec = '';
            this.query.sku = '';
            this.query.variationSku = '';
        },
        onPlatformChange(value) {
            this.query.platform = value;
            this.search();
        },
        onSortChange(value) {
            const state = this.sortState(value);
            if (state === 'none') {
                this.query.sortType = value;
            } else if (state === 'asc') {
                this.query.sortType = value === 0 ? 2 : 3;
            } else {
                this.query.sortType = null;
            }
            this.search();
        },
        sortState(value) {
            const t = this.query.sortType === null || this.query.sortType === undefined ? null : Number(this.query.sortType);
            if (value === 0) {
                if (t === 0) return 'asc';
                if (t === 2) return 'desc';
                return 'none';
            }
            if (value === 1) {
                if (t === 1) return 'asc';
                if (t === 3) return 'desc';
                return 'none';
            }
            return 'none';
        },
        isSortChecked(value) {
            return this.sortState(value) !== 'none';
        },
        sortIconClass(value) {
            return this.sortState(value);
        },
        onShopSelect(id) {
            this.query.shopId = id;
            this.search(); // 调用搜索方法，可按需调整
        },
        search(){
            this.$emit('search', this.query);
        },
        onPrintSelect(val){
            this.$emit('ctrl-click', val);
        },
        openBatchInputCode(){
            if(this.query.orderCode){
                this.batchInputCode = this.query.orderCode;
            }
            this.batchInputCodeVisible = true;
        },
        handleBatchInputCode(){
            let codes = this.batchInputCode.split(/[\s,，\n]+/);
            this.query.orderCode = codes.join(',');
            this.batchInputCodeVisible = false;
        },
        //匹配库存
        matchStock(){
            this.$emit('match-stock', '');
        }
    }
}
</script>

<style scoped>
.order-query-box {
    margin: 15px 0px;
    padding: 30px 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
}

.query-item{
    display:flex;
    align-items: top;
}

.query-item-content {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.custom-radio {
  display: inline-block;
  cursor: pointer;
  user-select: none;
}

.custom-radio input[type="radio"] {
  display: none;
}

.custom-radio-btn {
  display: inline-block;
  padding: 1px 12px;
  height: 28px;
  line-height: 26px;
  background: rgba(0,0,0,0.09);
  border-radius: 2px;
  color: #333;
  border: 1px solid transparent;
  transition: all 0.2s;
  font-size: 14px;
}

.sort-icons {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-left: 6px;
  vertical-align: middle;
}

.sort-triangle {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.sort-triangle.up {
  border-bottom: 6px solid #c0c4cc;
}

.sort-triangle.down {
  border-top: 6px solid #c0c4cc;
}

.sort-icons.asc .sort-triangle.up {
  border-bottom-color: #0052d9;
}

.sort-icons.desc .sort-triangle.down {
  border-top-color: #0052d9;
}

.custom-radio:hover .custom-radio-btn {
  background: #f2f3ff;
  color: #0052d9;
}

.custom-radio input[type="radio"]:checked + .custom-radio-btn {
  background: #f2f3ff;
  color: #0052d9;
  border: 1px solid #0052d9;
  white-space: nowrap;
}

.more-btn {
  border-radius: 2px;
  padding: 1px 12px;
  height: 32px;
  background: rgba(0,0,0,0.09);
  color: #0052d9;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
  outline: none;
  margin-left: 8px;
  line-height: 26px;
}
.more-btn:hover {
  background: #f2f3ff;
}

.query-item-title{
    width: 100px;
    min-width: 100px;
    text-align: right;
    margin-top: 5px;
    font-size: 14px;
}

.query-grid {
  display: flex;
  width: 100%;
}


.query-grid-cell3 {
  flex: 0 0 120px;
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.query-item-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 可选，行间距 */
}

.input-checkbox-flex {
  display: flex;
  align-items: center;
  width: 100%;
}
.input-flex {
  flex: 1 1 0;
  min-width: 0;
}
.checkbox-flex {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  margin-left: 10px;
}

.select-100 {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  margin-right: 8px;
}

.query-grid-cell1 {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0 24px;
}
.query-grid-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  min-width: 320px;
  flex: 1 1 320px;
  max-width: 500px;
  box-sizing: border-box;
}
.query-item-title {
  width: 90px;
  min-width: 90px;
  text-align: right;
  margin-right: 8px;
  font-size: 14px;
}
</style>
 
